// extracted by mini-css-extract-plugin
export default {"manualGroup":"styles_manualGroup__k47Tg","modalBtns":"styles_modalBtns__XrFqZ","loading":"styles_loading__n6Rfy"};